import { render, staticRenderFns } from "./warehouseCostAllocation.vue?vue&type=template&id=49a3eb12"
import script from "./warehouseCostAllocation.vue?vue&type=script&lang=js"
export * from "./warehouseCostAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports